
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '@/components/atoms/AppIcon.vue'

export default defineComponent({
  name: 'AppButton',
  components: { AppIcon },
  props: {
    icon: String,
    fill: Boolean,
    color: String,
    disabled: Boolean,
    loading: Boolean,
    size: String,
    to: String
  },
  setup(props, { slots }) {
    const router = useRouter()
    const square = ref(!slots.default)     

    function onClick() {
      props.to && router.push(props.to)
    }

    return { square, onClick }
  }
})
